import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { emit } from 'process';
import { InfoText, LanguageModel } from 'src/app/core/services/api-services';
import { LanguageService as ApiLanguageService } from 'src/app/core/services/api-services';


@Component({
    selector: 'app-floating-language-control',
    templateUrl: './floating-language-control.component.html',
    styleUrls: ['./floating-language-control.component.scss'],
    standalone: false
})
export class FloatingLanguageControlComponent {
  @Input() selectedLanguageControl!: FormControl<string | null>;
  @Input() possibleLanguages: LanguageModel[] = [];
  @Input() infoTooltip: string = '';
  @Input() infoTextKey!: InfoText;
  @Input() highlightFieldsTooltip: string = '';
  @Input() unhighlightFieldsTooltip: string = '';
  @Input() highlightFields: boolean = false;
  @Input() displayHighlightFields: boolean = true;
  @Input() style: string = '';


  @Output() selectedLanguageControlChange = new EventEmitter<string>();
  @Output() toggleHighlightControlChange = new EventEmitter<void>();

  constructor(
  ) {

  }

  ngOnChanges(): void {
    if (this.possibleLanguages.length > 0 && !this.possibleLanguages.some(x => x.languageCode == this.selectedLanguageControl.value)) {
      this.selectedLanguageControl.setValue(this.possibleLanguages![0].languageCode)
    }
  }

  onLanguageControlChange(event: any) {
    this.selectedLanguageControlChange.emit(event.value);
  }

  toggleHighlight() {
    this.toggleHighlightControlChange.emit();
  }
}
